import apiClient from '@utils/apiClient';
import { GrowthCropListRes } from '@/api/growth/crop/type';

export const api = {
    /**
     * 생육작물목록
     * @param param
     */
    growthCropList: async (): Promise<GrowthCropListRes> => {
        const response = await apiClient.get<GrowthCropListRes>(
            '/api/v1/growth/crop/list',
        );
        return response.data;
    },
};
